<template>
	<el-cascader :options="tree" :props="props" :size="'mini'" v-model="selectedOptions"></el-cascader>
</template>

<script>
export default {
	name: 'regionTree',
	data () {
		return {
			tree: [],
			props: {
				value: 'label'
			},
			selectedOptions: []
		}
	},
	props: ['value'],
	mounted () {
		this.tree = TJ_regionTree;
		this.selectedOptions = JSON.parse(JSON.stringify(this.value))
	},
	watch: {
		selectedOptions: {
			deep: true,
			handler (arr) {
				if (arr == this.value) return;
				this.$emit('input', arr);
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/regionTree.vue